"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));

var Divider_1 = __importDefault(require("@material-ui/core/Divider"));

var react_1 = __importStar(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var Header_1 = __importDefault(require("../../../Card/Header"));

var Transition_1 = __importDefault(require("../../../Transition"));

require("./style.scss");

var useStyles_1 = __importDefault(require("./useStyles"));
/**
 * Gallery image formatting component
 */


var GalleryImage = function GalleryImage(_a) {
  var className = _a.className,
      color = _a.color,
      content = _a.content,
      label = _a.label,
      noImage = _a.noImage,
      style = _a.style,
      src = _a.src;
  var classes = (0, useStyles_1.default)();

  var _b = (0, react_1.useState)(false),
      active = _b[0],
      setActive = _b[1];

  var handleCloseDialog = function handleCloseDialog() {
    return setActive(false);
  };

  var handleOpenDialog = function handleOpenDialog() {
    return setActive(true);
  };

  var closeBtn = react_1.default.createElement("div", {
    className: "close-btn",
    onClick: handleCloseDialog,
    onKeyPress: handleCloseDialog,
    role: "button",
    tabIndex: 0
  }, "X");

  var renderDialog = function renderDialog() {
    var dialogClasses = 'story-gallery-dialog';
    if (noImage) dialogClasses += ' no-image-layout';
    return react_1.default.createElement(Dialog_1.default, {
      classes: {
        paper: classes.dialog
      },
      className: dialogClasses,
      keepMounted: true,
      onClose: handleCloseDialog,
      open: active,
      TransitionComponent: Transition_1.default
    }, noImage ? react_1.default.createElement("div", {
      className: "story-gallery-dialog-body no-image-layout",
      style: {
        backgroundImage: "url(" + src + ")"
      }
    }, react_1.default.createElement("div", {
      className: "story-gallery-dialog-body__inner"
    }, react_1.default.createElement(Header_1.default, {
      text: label
    }), react_1.default.createElement(Divider_1.default, null), react_1.default.createElement("div", {
      className: "lightbox-content"
    }, content)), closeBtn) : react_1.default.createElement("div", {
      className: "story-gallery-dialog-body"
    }, react_1.default.createElement("img", {
      alt: label,
      className: "dialog-image",
      src: src
    }), react_1.default.createElement("div", {
      className: "story-gallery-dialog-body__content"
    }, react_1.default.createElement(Header_1.default, {
      text: label
    }), react_1.default.createElement(Divider_1.default, null), react_1.default.createElement("div", {
      className: "lightbox-content"
    }, content)), closeBtn));
  };

  var contentStyle = {
    color: color.text,
    textShadow: "3px 2px 0px " + color.background
  };

  var imageStyle = __assign(__assign({}, style), {
    backgroundImage: "url(" + src + ")"
  });

  var containerClasses = className + " story-gallery-image-container";
  if (noImage) containerClasses += ' no-image-layout';
  return react_1.default.createElement("div", {
    className: containerClasses
  }, react_1.default.createElement("div", {
    className: "story-gallery-image",
    onClick: handleOpenDialog,
    onKeyDown: handleOpenDialog,
    role: "button",
    style: imageStyle,
    tabIndex: 0
  }, react_1.default.createElement("div", {
    className: "story-gallery-image__contents",
    style: contentStyle
  }, react_1.default.createElement("div", {
    className: "story-gallery-image__contents-label"
  }, label))), renderDialog());
};

GalleryImage.propTypes = {
  /** Determines the background and text color of the `Image` label. */
  color: prop_types_1.default.shape({
    background: prop_types_1.default.string,
    text: prop_types_1.default.string
  }),

  /** Content to go underneath the title in a detail page */
  content: prop_types_1.default.node,

  /** Determines the main text of the `Image`. */
  label: prop_types_1.default.string.isRequired,

  /** Determines if the layout should emphasize the text or the image. */
  noImage: prop_types_1.default.bool,

  /** The destination URL of the `Image` */
  src: prop_types_1.default.string.isRequired,

  /** Custom CSS Props for the `Image` */
  // eslint-disable-next-line react/forbid-prop-types
  style: prop_types_1.default.object
};
GalleryImage.defaultProps = {
  color: {
    background: '#ffc7ed9e',
    text: '#000'
  },
  content: undefined,
  noImage: false,
  style: {}
};
exports.default = GalleryImage;